import { useEffect, useState } from 'react';
import superUserDebugService from '@/services/superUserDebugService.ts';
import type { DebugSessionDetail } from '@/types/superUserDebug.ts';

export interface UseSuperUserDebugSessionDetailResult {
  data: DebugSessionDetail | null;
  isLoading: boolean;
  error: string | null;
}

export function useSuperUserDebugSessionDetail(
  sessionId: string | undefined,
): UseSuperUserDebugSessionDetailResult {
  const [data, setData] = useState<DebugSessionDetail | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!sessionId) {
      setError('Missing session id');
      setIsLoading(false);
      return;
    }

    let cancelled = false;
    setIsLoading(true);
    setError(null);
    superUserDebugService
      .getSessionDetail(sessionId)
      .then((res) => {
        if (!cancelled) setData(res);
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Error');
          setData(null);
        }
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [sessionId]);

  return { data, isLoading, error };
}
